<template>
  <div class="buJianKanBan">
    <h1 style="text-align: center; margin-top: 0vh; line-height: 8vh;">部件看板</h1>
    <div style="background-color: #2D4054; margin: 1vh 0vh;">
      <div style="width: 96%; margin: 0 auto;">
        <div class="chart1" style="width: 33%; height: 35vh; float: left;"/>
        <div class="chart2" style="width: 33%; height: 35vh; float: left;"/>
        <div class="chart3" style="width: 33%; height: 35vh; float: left;"/>
      </div>
    </div>
    <table class="gridtable" style="width: 96%; margin: 0 auto;">
      <tr>
        <th colspan="2">轿顶盒</th>
        <th colspan="2">操纵</th>
        <th colspan="2">外召</th>
      </tr>
      <tr>
        <td style="width: 20%">生产中台数</td>
        <td style="width: 13%">{{scz1}}</td>
        <td style="width: 20%">生产中台数</td>
        <td style="width: 14%">{{scz2}}</td>
        <td style="width: 20%">生产中台数</td>
        <td style="width: 13%">{{scz3}}</td>
      </tr>
      <tr>
        <td>料齐未开工</td>
        <td>{{wkg1}}</td>
        <td>料齐未开工</td>
        <td>{{wkg2}}</td>
        <td>料齐未开工</td>
        <td>{{wkg3}}</td>
      </tr>
      <tr>
        <td>备料中台数</td>
        <td>{{bl1}}</td>
        <td>备料中台数</td>
        <td>{{bl2}}</td>
        <td>备料中台数</td>
        <td>{{bl3}}</td>
      </tr>
      <tr>
        <td>缺料台数</td>
        <td>{{ql1}}</td>
        <td>缺料台数</td>
        <td>{{ql2}}</td>
        <td>缺料台数</td>
        <td>{{ql3}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        date: new Date().getTime(),
        myChart1: null,
        myChart2: null,
        myChart3: null,
        scz1: 0,
        wkg1: 0,
        bl1: 0,
        ql1: 0,
        scz2: 0,
        wkg2: 0,
        bl2: 0,
        ql2: 0,
        scz3: 0,
        wkg3: 0,
        bl3: 0,
        ql3: 0,
        czwgl: 0,
        czjh: 0,
        czwg: 0,
        wzwgl: 0,
        wzjh: 0,
        wzwg: 0,
        jdwgl: 0,
        jdjh: 0,
        jdwg: 0,
      };
    },
    mounted() {
      this.getDTSList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      this.myChart3 = this.$echarts.init(document.querySelector(".chart3"));
      setInterval(() => {
        this.getDTSList();
        this.date = new Date().getTime();
      }, 1000 * 60 * 5);
    },
    methods: {
      getDTSList() {
        let params = {
          date: this.date,
        };
        this.$http.get("basic","kanban/getSpPartProductionList", params).then(res => {
          if (res) {
            this.scz1 = res[3].orderNum;
            this.scz2 = res[10].orderNum;
            this.scz3 = res[17].orderNum;
            this.wkg1 = res[4].orderNum;
            this.wkg2 = res[11].orderNum;
            this.wkg3 = res[18].orderNum;
            this.bl1 = res[5].orderNum;
            this.bl2 = res[12].orderNum;
            this.bl3 = res[19].orderNum;
            this.ql1 = res[6].orderNum;
            this.ql2 = res[13].orderNum;
            this.ql3 = res[20].orderNum;
            this.czwgl = res[0].orderNum;
            this.czjh = res[1].orderNum;
            this.czwg = res[2].orderNum;
            this.wzwgl = res[7].orderNum;
            this.wzjh = res[8].orderNum;
            this.wzwg = res[9].orderNum;
            this.jdwgl = res[14].orderNum;
            this.jdjh = res[15].orderNum;
            this.jdwg = res[16].orderNum;
            this.$nextTick(() => {
              this.refreshChart();
            });
          }
        });
      },
      refreshChart() {
        let option1 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n完工： " + this.czwg + "\n\n计划： " + this.czjh,
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.czwg/this.czjh, this.czwg/this.czjh],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.czwgl,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart1.setOption(option1);

        let option2 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n完工： " + this.wzwg + "\n\n计划： " + this.wzjh,
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.wzwg/this.wzjh, this.wzwg/this.wzjh],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.wzwgl,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart2.setOption(option2);

        let option3 = {
          backgroundColor: "#2D4054",
          title: {
            text: "\n\n\n完工： " + this.jdwg + "\n\n计划： " + this.jdjh,
            left: "left",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.fontSize(0.22),
              color: "RGB(255,255,255)",
              lineHeight: this.fontSize(0.27),
            },
          },
          series: [{
            type: "liquidFill",
            radius: "80%",
            data: [this.jdwg/this.jdjh, this.jdwg/this.jdjh],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "RGB(60,204,214)",
              color: "RGB(63,97,119)",
            },
            label: {
              normal: {
                formatter: this.jdwgl,
                textStyle: {
                  fontSize: this.fontSize(0.3),
                  color: "#fff",
                  fontWeight: "bold",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "RGB(68,130,216)",
              },
            },
          }],
        };
        this.myChart3.setOption(option3);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .buJianKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    table.gridtable {
      height: 45vh;
      font-family: verdana,arial,sans-serif;
      font-size: 3.2vh;
      color:#ffffff;
      border-width: 1px;
      border-color: #dddddd;
      border-collapse: collapse;
    }
    table.gridtable th {
      font-size: 3.5vh;
      text-align: center;
      border-width: 1px;
      border-style: solid;
      border-color: #dddddd;
    }
    table.gridtable td {
      border-width: 1px;
      border-style: solid;
      border-color: #dddddd;
    }
  }
</style>
